import { c as _c } from "react/compiler-runtime";
import { Image } from '@/app/components/media/image';
import { Link } from '@/app/components/navigation/link';
import { FreeText, ItemRow, ItemRowDetail } from '@/app/lcv/components/sections/calculator/result/privilege-table/sub-components';
import { type PrivilegeTableProps } from '@/app/lcv/types/calculator';
interface Coupon {
  coupon: PrivilegeTableProps['coupon'];
}
interface MyMember {
  myMember: PrivilegeTableProps['myMember'];
}
interface Isp {
  isp: PrivilegeTableProps['isp'];
}
export const PrivilegeCouponRow = t0 => {
  const $ = _c(13);
  const {
    coupon
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image src="https://assets.isuzu-tis.com/coupon_f8f476a9fc.png" alt="Coupon" width={91} height={72} sizes="100px" layout="fill" className="relative mx-auto h-16 w-20" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span>ส่วนลดตรวจเช็กตามระยะ</span>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <br className="block lg:hidden" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== coupon.description) {
    t4 = <div className="lg:text-left">{t2} {t3}<span className="font-noto-bold text-red-500">{coupon.description}</span></div>;
    $[3] = coupon.description;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== coupon.price) {
    t5 = <span className="font-noto-bold text-sub-h2 text-gray-900">{coupon.price}</span>;
    $[5] = coupon.price;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FreeText text={"\u0E1F\u0E23\u0E35"} />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5) {
    t7 = <div className="flex items-baseline justify-center lg:justify-end lg:pr-10">{t5}{t6}</div>;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t4 || $[11] !== t7) {
    t8 = <ItemRow>{t1}<ItemRowDetail>{t4}{t7}</ItemRowDetail></ItemRow>;
    $[10] = t4;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};
export const PrivilegeExcellencyRow = t0 => {
  const $ = _c(16);
  const {
    myMember
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image src="https://assets.isuzu-tis.com/my_member_logo_ce503dd772.svg" alt="my-MEMBER" width={224} height={36} sizes="100px" layout="fill" className="relative mx-auto h-9 w-56 scale-80" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span>สิทธิ์สมาชิก ISUZU my-MEMBER</span>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span>รับการดูแลที่เหนือกว่า</span>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <br className="hidden md:block" />;
    t5 = <span>ด้วยส่วนลดพิเศษที่ศูนย์บริการ</span>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span>ส่วนลดซื้อรถอีซูซุคันใหม่</span>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span>(โอนสิทธิได้)</span>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <br className="hidden md:block" />;
    t9 = <span>พร้อมสิทธิประโยชน์ไลฟ์สไตล์</span>;
    $[7] = t8;
    $[8] = t9;
  } else {
    t8 = $[7];
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span>ทั้งกิน ดื่ม และท่องเที่ยว</span>;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="lg:text-left">{t2}{" "}{t3} {t4}{t5}{" "}{t6} {t7}{" "}{t8}{t9}{" "}{t10}{" "}<span>จากแบรนด์ชั้นนำทั่วประเทศ </span>{" "}</div>;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== myMember.cta) {
    t12 = <Link theme="light" href={myMember.cta} target="_blank" className="text-body-1">ดูรายละเอียด</Link>;
    $[11] = myMember.cta;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <FreeText text={"\u0E1F\u0E23\u0E35"} />;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== t12) {
    t14 = <ItemRow>{t1}<ItemRowDetail>{t11}<div className="mt-0.5 flex items-baseline justify-center lg:mt-0 lg:justify-end lg:pr-10">{t12}{t13}</div></ItemRowDetail></ItemRow>;
    $[14] = t12;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  return t14;
};
export const PrivilegeIspRow = t0 => {
  const $ = _c(17);
  const {
    isp
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image src="https://assets.isuzu-tis.com/isuzu_smart_protection_95f120cc63.svg" alt="ISUZU Smart Protection" width={79} height={72} sizes="100px" layout="fill" className="relative mx-auto h-18 w-20" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span>โปรแกรมขยายระยะเวลาการคุ้มครอง</span>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <br className="block lg:hidden" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isp.mileage) {
    t4 = <span className="font-noto-bold text-red-500">{isp.mileage}</span>;
    $[3] = isp.mileage;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <br className="block lg:hidden" />;
    t6 = <span>(สำหรับลูกค้าอีซูซุลิสซิ่ง)</span>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4) {
    t7 = <div className="lg:text-left">{t2}{" "}{t3}{t4}{" "}{t5}{t6}</div>;
    $[7] = t4;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== isp.price) {
    t8 = <span className="font-noto-bold text-sub-h2 text-gray-900">{isp.price}</span>;
    $[9] = isp.price;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <FreeText text={"\u0E1F\u0E23\u0E35"} />;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t8) {
    t10 = <div className="flex items-baseline justify-center lg:justify-end lg:pr-10">{t8}{t9}</div>;
    $[12] = t8;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t7) {
    t11 = <ItemRow>{t1}<ItemRowDetail>{t7}{t10}</ItemRowDetail></ItemRow>;
    $[14] = t10;
    $[15] = t7;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
};